import { render, staticRenderFns } from "./StorySevenView.vue?vue&type=template&id=3452a96c&"
import script from "./StorySevenView.vue?vue&type=script&lang=js&"
export * from "./StorySevenView.vue?vue&type=script&lang=js&"
import style0 from "./StorySevenView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports